import ZoneContainer from './containers/ZoneContainer';

export default ZoneContainer;